
/**
* Estou na store de tipos de usuarios
*/

import state from './state'
import actions from './actions'
import mutations from './mutations'

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/features/admin/tiposUsuarios/store/index.js